module.exports = __webpack_public_path__ + "static/media/combo_v2.21851888.png";